import React from 'react';
import Img from "../../images/services/dt/custom.png";
import {Container, Row, Col} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Buildpurpose(props) {
    return (
        <div className="services_orange_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto text-center order-2 order-md-1">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="services_title my-auto order-1 order-md-2">
                        <h2> Everything To Ensure Your Digital Excellence</h2>
                        <p>The immense competition in the digital realm has forced companies and brands to be on their
                            toes. Similarly, it has become incrementally difficult for startups and legacy businesses to
                            transform digitally. That is where TekRevol’s digital transformation services come in handy
                            to ensure your digital excellence.</p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Buildpurpose;